import { computed } from 'vue';
import { usePage } from '@inertiajs/inertia-vue3';
export default function useExamination() {
    const { props: pageProps } = usePage();
    const examination = computed(() => pageProps.value.examination);
    const currentExaminationId = computed(() => pageProps.value.currentExaminationId);
    const currentExaminationType = computed(() => pageProps.value.currentExaminationType);
    return {
        examination,
        currentExaminationId,
        currentExaminationType,
    };
}
